function runMatchLogic() {
  const starCueSize = localStorage.getItem('starcueSize');
  const modalEvent = localStorage.getItem('starCueModalEvent');
  const tokenElement = document.getElementById('starcue-token');
  const accessToken = tokenElement ? tokenElement.dataset.token : null;

  if (!accessToken) {
    console.error('API token not found. Please check the snippet configuration.');
    return;
  }

  if (starCueSize && (modalEvent === 'true' || modalEvent === null)) {
    const products = document.querySelectorAll('.product-meta-size');

    for (const product of products) {
      console.log('Product HTML:', product.innerHTML);

      // Zugriff auf die Größe aus dem Metafield
      const sizeDataElement = product.querySelector('.product-size-data');
      const productSize = sizeDataElement ? sizeDataElement.dataset.value || sizeDataElement.textContent.trim() : null;

      console.log('Product Size:', productSize);

      if (productSize) {
        fetch('https://starcue-daedalus.de/starcue_technology/compare-starcue-size/', {
          method: 'POST',
          headers: {
            'Authorization': `Token ${accessToken}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            target_size: starCueSize,
            clothing_size: productSize,
          }),
        })
        .then(response => {
          if (!response.ok) {
            throw new Error(`Error: ${response.statusText}`);
          }
          return response.json();
        })
        .then(data => {
          if (data && data.fit_accuracy) {
            updateFitUI(product, data.fit_accuracy);
          } else {
            console.error('Invalid API response format:', data);
          }
        })
        .catch(error => {
          console.error('API error:', error);
        });
      } else {
        console.warn('Product size not found.');
      }
    }

    // Reset modal event flag after processing
    localStorage.removeItem('starCueModalEvent');
  } else {
    console.warn('No StarCue size found or no modal event triggered.');
  }
}

// Update UI with match data
function updateFitUI(product, fitAccuracy) {
  // Extrahiere die Werte aus der API-Antwort
  const overallFitAccuracy = fitAccuracy.overall_fit_accuracy;
  const widthDiff = fitAccuracy.width_diff;
  const lengthDiff = fitAccuracy.length_diff;

  // Update Match Percentage
  const matchValueElement = product.querySelector('.size-match-section .match-item:nth-child(1) p');
  if (matchValueElement) {
    matchValueElement.textContent = `${overallFitAccuracy}%`;
  }

  // Update Hint (Width and Length Trends)
  const hintElement = product.querySelector('.size-match-section .match-item:nth-child(2) p');
  if (hintElement) {
    const widthTrend = widthDiff > 2 ? "eher zu breit" : widthDiff < -2 ? "eher zu eng" : "perfekt";
    const lengthTrend = lengthDiff > 2 ? "eher zu lang" : lengthDiff < -2 ? "eher zu kurz" : "perfekt";

    hintElement.textContent = `In der Breite ist es ${widthTrend} und in der Länge ist es ${lengthTrend}.`;
  }

  // Update Recommendation
  const recommendationElement = product.querySelector('.size-match-section .match-item:nth-child(3) p');
  if (recommendationElement) {
    let recommendation = "";
    if (overallFitAccuracy >= 95) {
      recommendation = "Perfekt geeignet.";
    } else if (overallFitAccuracy >= 89) {
      recommendation = "Geeignet mit ein paar kleinen Abweichungen.";
    } else if (overallFitAccuracy >= 75) {
      recommendation = "Wir empfehlen den Kauf nur, wenn die in den Hinweisen angegebenen Abweichungen gewünscht sind.";
    } else {
      recommendation = "Überhaupt nicht geeignet, vom Kauf wird abgeraten.";
    }
    recommendationElement.textContent = recommendation;
  }
}

// Listen for DOMContentLoaded
document.addEventListener('DOMContentLoaded', runMatchLogic);
document.addEventListener('StarCueSizeUpdated', runMatchLogic);